export default {
    detail: "Результат привязки",
    getDetailFailure: "Не удалось получить результат привязки",
    addTitle: "Массовая привязка",
    entity: "Организация привязки",
    message_importEntity: "Организация привязки не может быть пустой",
    downloadTemplate: "Скачать шаблон",
}
